<template>
  <v-dialog v-model="dialog" max-width="800px" scrollable persistent>
    <v-card class="terms-card">
      <v-card-title class="terms-title">
        <h3>Terms & Conditions</h3>
      </v-card-title>
      <v-card-text class="terms-body">
        <div class="terms-text">
          <h3>1. Packages & Pricing</h3>
          <p>Silver Package: – 1 scheduled visit / year</p>
          <p>Gold Package: – 2 scheduled visits / year</p>
          <p>Platinum Package: – 4 scheduled visits / year</p>
          <p>
            Each package is valid for 12 months from the date of purchase and is non-transferable.
          </p>

          <h3>2. Services Included</h3>
          <ul>
            <li>Home deep cleaning & pest control</li>
            <li>Regular inspection & maintenance checks</li>
            <li>Reorganization & decluttering support</li>
            <li>AC servicing (standard servicing only, spare parts billed separately)</li>
            <li>Furniture & upholstery cleaning</li>
            <li>
              Electrical & plumbing checks (minor repairs included; major repairs billed separately)
            </li>
            <li>Water tank cleaning</li>
          </ul>

          <h3>3. Service Terms</h3>
          <p>
            All services must be pre-booked at least 48 hours in advance through OhYes Home
            Solutions’ platform.
          </p>
          <p>Unused services cannot be carried forward beyond the 12-month subscription period.</p>
          <p>Services are performed during standard working hours (9 AM – 6 PM, Mon–Sat).</p>
          <p>Emergency or after-hours services may incur additional charges.</p>

          <h3>4. Exclusions</h3>
          <p>
            The following are not included: Spare parts, structural repairs, major
            electrical/plumbing/HVAC repairs, emergency services outside business hours, or services
            not expressly listed.
          </p>

          <h3>5. Payments & Renewal</h3>
          <p>Package fees must be paid in full at the time of subscription.</p>
          <p>Packages auto-renew unless cancelled at least 30 days before expiry.</p>
          <p>
            Illinois Disclosure: By subscribing, you authorize OhYes Home Solutions to automatically
            renew your package each year. Customers will receive written notice of renewal terms at
            least 30 days prior.
          </p>

          <h3>6. Cancellation & Refunds</h3>
          <p>Packages are non-refundable. Future renewals can be cancelled with 30 days’ notice.</p>

          <h3>7. Liability & Customer Responsibility</h3>
          <p>
            OhYes Home Solutions is not liable for indirect damages. Liability limited to the
            subscription fee. Customers must provide safe access to property.
          </p>

          <h3>8. Indemnification</h3>
          <p>
            Customers agree to indemnify OhYes Home Solutions from claims arising from negligence or
            unsafe conditions.
          </p>

          <h3>9. Conduct & Behaviour</h3>
          <p>
            Customers must treat staff respectfully. Abuse may result in termination without refund.
          </p>

          <h3>10. Dispute Resolution</h3>
          <p>Disputes handled via customer support, then arbitration in Cook County, Illinois.</p>

          <h3>11. Governing Law</h3>
          <p>
            These Terms are governed by Illinois law. OhYes reserves the right to modify terms
            anytime.
          </p>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="terms-actions">
        <v-checkbox
          v-model="accepted"
          label="I have read and agree to the Terms & Conditions"
          color="#f46523"
          hide-details
          class="terms-checkbox"
        />
        <v-spacer />
        <v-btn text class="close-btn" @click="dialog = false">Close</v-btn>
        <v-btn color="#f46523" dark class="accept-btn" @click="confirm" :disabled="!accepted">
          Accept
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TermsModal',
  data() {
    return {
      dialog: false,
      accepted: false,
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.accepted = false;
    },
    confirm() {
      this.dialog = false;
      this.$emit('accepted', true);
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700;900&display=swap');

.terms-card {
  font-family: 'Nunito Sans', sans-serif;
  border-radius: 16px;
  overflow: hidden;
}

.terms-title {
  font-size: 22px;
  color: #f46523;
  padding: 20px;
  border-bottom: 1px solid #f1f1f1;
  font-weight: 800;
}

.terms-body {
  max-height: 400px;
  overflow-y: auto;
  padding: 24px;
}

.terms-text {
  font-size: 14px;
  line-height: 1.7;
  color: #444;
}

.terms-text h3 {
  margin-top: 20px;
  margin-bottom: 6px;
  font-size: 16px;
  font-weight: 700;
  color: #f46523;
}

.terms-text p,
.terms-text li {
  margin-bottom: 8px;
}

.terms-text ul {
  padding-left: 20px;
  margin: 6px 0;
}

.terms-actions {
  padding: 16px 24px;
}

.terms-checkbox {
  font-size: 14px;
  color: #333;
}

.close-btn {
  font-weight: 600;
  color: #64748b;
  text-transform: none;
}

.accept-btn {
  font-weight: 700;
  padding: 10px 24px;
  border-radius: 8px;
  text-transform: none;
  font-size: 12px;
  border-radius: 20px;
}
</style>
